export const iconGroupPanelWrapperStyles = {
  display: 'flex',
  gap: '24px',
};

export const iconGroupPanelItemStyles = {
  flex: 1,
};
